import type { ConditionOperator } from '@ricoh/ria.client.core/constants/core/data.type';

import type { DataTypeNameGeneral } from '~/common/model/api/common';

const equalOperators: ConditionOperator[] = ['equals', 'notEquals'];
const greaterLessOperators: ConditionOperator[] = ['greaterThan', 'greaterThanOrEquals', 'lessThan', 'lessThanOrEquals'];
const containOperators: ConditionOperator[] = ['contains', 'notContains'];
const inOperators: ConditionOperator[] = ['in', 'notIn'];
const positionOperators: ConditionOperator[] = ['startsWith', 'notStartsWith', 'endsWith', 'notEndsWith'];
const matchOperators: ConditionOperator[] = ['match', 'notMatch'];

/** Condition Operators. */
export const CONDITION_OPERATORS: Record<DataTypeNameGeneral | 'list', ConditionOperator[]> = {
  text: [...equalOperators, ...containOperators, ...inOperators, ...positionOperators],
  decimal: [...equalOperators, ...greaterLessOperators, ...inOperators],
  integer: [...equalOperators, ...greaterLessOperators, ...inOperators],
  currency: [...equalOperators, ...greaterLessOperators, ...inOperators],
  boolean: [...equalOperators, ...inOperators],
  datetime: [...equalOperators, ...greaterLessOperators, ...inOperators],
  date: [...equalOperators, ...greaterLessOperators, ...inOperators],
  time: [...equalOperators, ...greaterLessOperators, ...inOperators],
  list: [...containOperators],
};

/** Condition Operators Import Outlook. */
export const CONDITION_OPERATORS_IMPORT_OUTLOOK: Record<DataTypeNameGeneral | 'list', ConditionOperator[]> = {
  text: [...equalOperators, ...containOperators, ...positionOperators, ...matchOperators],
  decimal: [...equalOperators, ...greaterLessOperators, ...matchOperators],
  integer: [...equalOperators, ...greaterLessOperators, ...matchOperators],
  currency: [...equalOperators, ...greaterLessOperators, ...matchOperators],
  boolean: [...equalOperators],
  datetime: [...equalOperators, ...greaterLessOperators, ...matchOperators],
  date: [...equalOperators, ...greaterLessOperators, ...matchOperators],
  time: [...equalOperators, ...greaterLessOperators, ...matchOperators],
  list: [...containOperators],
};

/** Condition Operators Validation. */
export const VALIDATION_CONDITION_OPERATORS: Record<DataTypeNameGeneral | 'list', ConditionOperator[]> = {
  text: [...equalOperators, ...containOperators, ...positionOperators, ...matchOperators],
  decimal: [...equalOperators, ...greaterLessOperators],
  integer: [...equalOperators, ...greaterLessOperators],
  currency: [...equalOperators, ...greaterLessOperators],
  boolean: [...equalOperators],
  datetime: [...equalOperators, ...greaterLessOperators],
  date: [...equalOperators, ...greaterLessOperators],
  time: [...equalOperators, ...greaterLessOperators],
  list: [...containOperators],
};
